import { useState } from "react";
import { fullName } from "../../helperfunctions/helperfunctions";
import { handleData } from "../../api";

const AdminSingleUserData = (props) => {

    const { user } = props;
    const { gebruikersnaam, contactpersoon, admin, superadmin, _id } = user;
    const naam = fullName(user);
    const [adminchange, setAdminchange] = useState({
        haschanged: false,
        contactpersoon: contactpersoon,
        admin: admin,
        superadmin: superadmin
    });


    const handleChange =(e) => {
        const name = (e.target.name);
        setAdminchange((prevState) => {
            return {
                ...prevState,
                haschanged: true,
                [name]: !prevState[name]
            };
        });
        
    }

    const handleSubmit = async() => {
        const path = `users/update/${_id}`;
        const input = {
            contactpersoon: adminchange.contactpersoon,
            admin: adminchange.admin,
            superadmin: adminchange.superadmin
        }
        const data = {
            method: 'PATCH',
            path: path,
            input: input
        }
        const editAdminPermissions = await handleData(data);
        setAdminchange({
            ...adminchange,
            haschanged: false
        });
    }


    return (
        <>
            <tr>
                <td>
                    <p>{naam}</p>
                </td>
                <td>
                    <p>{gebruikersnaam}</p>
                </td>
                <td>
                    <input 
                        type="checkbox" 
                        name="contactpersoon" 
                        id="contactpersoon" 
                        checked={adminchange.contactpersoon ? "checked" : ""} 
                        onChange={handleChange}
                    />
                </td>
                <td>
                    <input 
                        type="checkbox" 
                        name="admin" 
                        id="admin" 
                        checked={adminchange.admin ? "checked" : ""} 
                        onChange={handleChange}
                    />
                </td>
                <td>
                    <input 
                        type="checkbox" 
                        name="superadmin" 
                        id="superadmin" 
                        checked={adminchange.superadmin ? "checked" : ""} 
                        onChange={handleChange}
                    />
                </td>
                <td>
                    {adminchange.haschanged && <button onClick={handleSubmit}>Bevestig wijziging</button> }
                    
                </td>
            </tr>
        </>
    );
}

export default AdminSingleUserData;